
import api from '@/api';

const namespaced = true;

const state = {};

const mutations = {};

const actions = {
  async fetchListForMaker(store, makerId) {
    try {
      const { data: recurrentInterventions } = await api.get(`/recurrent-interventions/maker/${makerId}`);

      return recurrentInterventions;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async fetchListForMakerAndClient(store, { makerId, clientId }) {
    try {
      const { data: recurrentInterventions } = await api.get(`/recurrent-interventions/maker/${makerId}/client/${clientId}`);

      return recurrentInterventions;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async add({ dispatch }, recurrentIntervention) {
    try {
      const { data: apiRecurrentIntervention } = await api.post(`/recurrent-interventions`, recurrentIntervention);
      dispatch(`ui/mainLayout/fetchCountInboxInterventions`, null, { root: true });

      return apiRecurrentIntervention;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async update({ dispatch }, recurrentIntervention) {
    try {
      const { data: apiRecurrentIntervention } = await api.put(`/recurrent-interventions/${recurrentIntervention.id}`, recurrentIntervention);
      dispatch(`ui/mainLayout/fetchCountInboxInterventions`, null, { root: true });

      return apiRecurrentIntervention;
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async remove({ dispatch }, recurrentInterventionId) {
    try {
      await api.delete(`/recurrent-interventions/${recurrentInterventionId}`);
      dispatch(`ui/mainLayout/fetchCountInboxInterventions`, null, { root: true });

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
